<script setup>
const props = defineProps(["class"]);
</script>

<template>
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		:class="class"
	>
		<path
			d="M12.5245 3.5791L14.9327 7.7506H17.5V9.2506H16.6248L16.057 16.0629C16.0414 16.2503 15.9559 16.425 15.8176 16.5524C15.6792 16.6797 15.4981 16.7505 15.31 16.7506H4.69C4.50193 16.7505 4.32077 16.6797 4.18242 16.5524C4.04406 16.425 3.95861 16.2503 3.943 16.0629L3.3745 9.2506H2.5V7.7506H5.0665L7.4755 3.5791L8.7745 4.3291L6.799 7.7506H13.2003L11.2255 4.3291L12.5245 3.5791ZM15.1195 9.2506H4.87975L5.38 15.2506H14.6193L15.1195 9.2506ZM10.75 10.7506V13.7506H9.25V10.7506H10.75ZM7.75 10.7506V13.7506H6.25V10.7506H7.75ZM13.75 10.7506V13.7506H12.25V10.7506H13.75Z"
			fill="currentColor"
		/>
	</svg>
</template>
